module.exports = __webpack_public_path__ + "img/accion-popular.eba77a45.png";